<template>
  <div :class="classMap" @click="handleOptionClick">
    <div class="option-bundle-popup-item__left">
      <nio-radio-v2
        v-if="selectable"
        :selected="option.selected === 1"
        class="option-bundle-popup-item__radio"
        @click="handleOptionClick"
      />
      <div class="option-bundle-popup-item__image-wrap">
        <img
          class="option-bundle-popup-item__image"
          :src="option.small_img_url || option.img_url || defaultImg"
          :alt="option.name || ''"
        />
      </div>
      <div class="option-bundle-popup-item__name">{{ option.name }}</div>
      <nio-icon
        v-if="showDetailIcon"
        class="option-bundle-popup-item__detail"
        type="info"
        @click.stop="emit('viewDetail')"
      />
    </div>
    <div class="option-bundle-popup-item__right">
      <div class="option-bundle-popup-item__price-wrap">
        <div
          v-if="option.origin_price"
          class="option-bundle-popup-item__origin-price"
        >
          {{ formatPrice(option.origin_price, true) }}
        </div>
        <div class="option-bundle-popup-item__price">
          {{ formatPrice(option.price, option.origin_price) }}
        </div>
      </div>
      <img
        v-if="option.discount_icon_v2"
        class="option-bundle-popup-item__discount"
        :src="option.discount_icon_v2"
        alt=""
      />
    </div>
  </div>
</template>

<script setup>
import { formatPrice } from "@common/utils";

const emit = defineEmits(["select", "viewDetail"]);

const props = defineProps({
  option: {
    type: Object,
    default: () => ({}),
  },
  selectable: {
    type: Boolean,
    default: false,
  },
});

const defaultImg =
  "https://cdn-fx.nio.com/fx/configurator-website-3D/whZGhASNNvKK4JUkBSEQe/icon_logo.png";

const classMap = computed(() => ({
  "option-bundle-popup-item": true,
  "option-bundle-popup-item--selectable": props.selectable,
}));

const showDetailIcon = computed(
  () => props.option?.detail_desc_url || props.option?.have_detail
);

const handleOptionClick = () => {
  if (props.selectable && !props.option.selected) {
    emit("select");
  }
};
</script>
